import React from 'react'
import pdfLogo from "../../assets/images/binnys_logo_pdf.png";

const OrderPdfComp = ({selectedData,printRef}) => {
  return (
    <div  style={{position: "absolute", left: "-9999px", top: 0 }}>
        <div ref={printRef} id="pdf-content" style={{ color:"black",width: "600px", padding: "20px", fontFamily: "Arial" }}>
          <div style={{display:"flex",justifyContent:"space-between"}}>
            <div>
              <h2><strong>Invoice</strong></h2>
              <p><strong>Name:</strong>{selectedData?.client_name}</p>
              <p><strong>Invoice number:</strong> 450AA44E-0005</p>
              <p><strong>Date of issue:</strong> February 10, 2023</p>
              <p><strong>Due date:</strong> February 10, 2023</p>
            </div>
            <div style={{height:"50px",width:"150px"}}>
              <img style={{objectFit:"fill"}} src={pdfLogo} alt="pdf_logo"  />
            </div>
          </div>
          <div style={{ display: "flex",justifyContent:"space-between", marginTop: "20px"}}>
            <div>
              <h4><b>Figma, Inc.</b></h4>
              <p>
                760 Market Street<br />
                Floor 4<br />
                San Francisco, California 94102<br />
                United States<br />
                support@figma.com</p>
            </div>

            <div style={{width:"300px"}}>
              <h4><b>Bill to</b></h4>
              <p>Binny's Jewellery Pvt Ltd<br />
                14/A, 1st Floor, Popper Bdx, Mahakali Caves Rd<br />
                Andheri East, Mumbai 400093<br />
                Maharashtra, India</p>
            </div>
          </div>

          <h3 style={{ color: "blue", marginTop: "20px" }}>$45.00 USD due February 10, 2023</h3>

          <table style={{ width: "100%", marginTop: "20px", borderCollapse: "collapse" }}>
            <thead>
              <tr style={{ background: "#f0f0f0" }}>
                <th align="left">Description</th>
                <th>Qty</th>
                <th>Unit Price</th>
                <th>Amount</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Professional Figma seats (monthly)</td>
                <td align="center">3</td>
                <td align="center">$15.00</td>
                <td align="center">$45.00</td>
              </tr>
            </tbody>
          </table>

          <div style={{ textAlign: "right", marginTop: "20px" }}>
            <p><strong>Subtotal:</strong> $45.00</p>
            <p><strong>Total:</strong> $45.00</p>
            <p><strong>Amount due:</strong> <strong>$45.00</strong></p>
          </div>
        </div>
      </div>

  )
}

export default OrderPdfComp